export const FIND_ASSIGNABLE_ROUTINE_ADDONS = `
  query FindAssignableAddonsForRoutine($filter: FindAssignableRoutineAddonsFilter!, $page: PageRequest, $orderBy: OrderByInput) {
    routine {
      findAssignableAddonsForRoutine(filter: $filter, page: $page, orderBy: $orderBy) {
        count
        limit
        offset
        items { id name inAssignments }
      }
    }
  }
`;
